module.exports = __webpack_public_path__ + "static/media/big_notification_bell.aac96fad.svg";